import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=74310d18&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=74310d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74310d18",
  null
  
)

export default component.exports